import { Button } from "antd";
import { BulbFilled, EyeFilled, UsergroupAddOutlined, ArrowRightOutlined } from "@ant-design/icons";

function AboutUs() {
    return (
        <div className="about-us">
            <h2>A Glimpse Behind PreNumbers</h2>
            <div className="info-container">
                <div className="ceo-profile">
                    <div className="ceo-image-cont">
                        <img width={200} height={200} src="/ceo.jpg" alt="CEO Profile" />
                    </div>
                    <h3>Bjarni Kristjansson</h3>
                    <p>CEO & Founder</p>
                    <p className="quote">
                        "Our mission is to empower every entrepreneur with the financial clarity they need to not just succeed, but to truly thrive."
                    </p>
                </div>
                <div className="company-mission">
                    <h3><BulbFilled /> Our Mission</h3>
                    <p>To empower entrepreneurs and business owners with accessible, intuitive, and powerful financial tools, demystifying business finance for informed decisions and thriving enterprises.</p>
                    <h3><EyeFilled /> Our Vision</h3>
                    <p>To be the leading platform for proactive financial management, enabling every business to achieve clarity and foresight for global success.</p>
                    <h3><UsergroupAddOutlined /> Our Team</h3>
                    <p>Our team is composed of industry experts and passionate developers dedicated to providing the best financial solutions for businesses.</p>
                    <Button className="learn-more-button">Learn More About Us <ArrowRightOutlined className="learn-more-icon" /></Button>
                </div>
            </div>
        </div>
    );
}


export default AboutUs;